<template>
  <v-dialog
    persistent
    v-bind="[$attrs, $props]"
    content-class="base__modal pa-10"
    max-width="70%"
  >
    <div class="d-flex justify-space-between align-baseline mb-8">
      <h3 class="primary--text">ANEXAR DOCUMENTOS</h3>
      <v-btn text @click="$emit('close')">
        <v-icon class="fa dialog__close-btn">fa-times</v-icon>
      </v-btn>
    </div>
    <v-form ref="form" @submit.prevent="submit">
      <BalanceFormSection
        ref="balanceForm"
        v-model="dates"
        :multiple="true"
        @selected-files="onSelectedFiles"
        :error-messages="errorMessages"
        :documents="documents"
      />
      <DocumentDataTable
        class="mt-10"
        v-bind="[$attrs]"
        :documents="documents"
        @remove-file="onRemoveFile"
        @preview-file="onPreviewFile"
        v-if="documents.length > 0"
      />
      <div class="d-flex justify-end my-8">
        <BaseButton type="submit" class="secondary" min-width="200">
          ADICIONAR
        </BaseButton>
      </div>
    </v-form>
  </v-dialog>
</template>

<script>
import { FILE } from "@/mixins/DocumentsMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import BalanceFormSection from "@/components/form/BalanceFormSection.vue";
import DocumentDataTable from "@/components/DocumentDataTable.vue";

export default {
  name: "BalanceModal",
  components: { BalanceFormSection, DocumentDataTable },
  props: {
    formModel: { type: Object }
  },
  mixins: [DocumentsMixin],
  data() {
    return {
      dates: {
        inicio: "",
        fim: ""
      },
      documents: [],
      errorMessages: []
    };
  },
  methods: {
    onRemoveFile(document) {
      this.documents = this.documents.filter(
        doc => doc.arquivo.nome !== document.arquivo.nome
      );
    },
    onSelectedFiles(files) {
      this.documents = this.documents.concat(
        files.map(file => ({
          arquivo: {
            [FILE]: file,
            nome: file.name
          }
        }))
      );
    },
    validate() {
      this.errorMessages =
        this.documents.length > 0 ? [] : ["É preciso adicionar o balanço"];
      return this.documents.length > 0 && this.$refs.form.validate();
    },
    submit() {
      const { inicio, fim } = this.dates;

      if (!this.validate()) {
        return;
      }

      const docs = this.documents.map(doc => ({
        inicio,
        fim,
        ...doc
      }));
      this.$emit("submit", docs);
    }
  }
};
</script>

<style lang="sass">
.truncate
  max-width: 300px
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
</style>
